import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Grid } from 'semantic-ui-react';

import { ReceivingDelivery } from '../../../app/models/ReceivingDelivery';
import { useStore } from '../../../app/stores/store';
import BarcodeGenerator from '../../../app/common/modals/BarCode/BarCodeGenerator';
import QrCodeGenerator from '../../../app/common/modals/QrCode/QrCodeGenerator';
import RfidScanner from '../../../app/common/modals/Rfid/RfidScanner';
interface Props {
  physical_sensor_RFID: string;
  physical_sensor_barcode: string;
  physical_sensor_qrcode: string;
}

function CaptureButtonsForTag({
  physical_sensor_RFID,
  physical_sensor_barcode,
  physical_sensor_qrcode,
}: Props) {
  const { receivingdeliveryStore } = useStore();
  const { selectedReceivingDelivery } = receivingdeliveryStore;

  const [receivingDeliveryStateForUpdate, setreceivingDeliveryStateForUpdate] =
    useState<ReceivingDelivery | undefined>();
  useEffect(() => {
    setreceivingDeliveryStateForUpdate(selectedReceivingDelivery);
  }, [selectedReceivingDelivery, receivingDeliveryStateForUpdate]);

  return (
    <Grid>
      <Grid.Row columns={3}>
        <Grid.Column>
          <QrCodeGenerator id={physical_sensor_qrcode} />
        </Grid.Column>
        <Grid.Column>
          <BarcodeGenerator id={physical_sensor_barcode} />
        </Grid.Column>
        <Grid.Column>
          <RfidScanner />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default observer(CaptureButtonsForTag);
